import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const DrawingEditorToolDrawV2Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon drawing-editor-tool-draw-v-2"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="m12.1 4.311 2.66-2.25a1.667 1.667 0 0 1 2.255.094l.778.777c.613.613.653 1.594.094 2.255l-2.25 2.66m-8.252 7.998-2.131.913a.83.83 0 0 1-.918-.177l-.97-.97a.83.83 0 0 1-.177-.917l.914-2.131a8.3 8.3 0 0 1 1.767-2.61l5.347-5.347c.65-.65 1.706-.65 2.357 0l1.768 1.768c.65.65.65 1.706 0 2.357l-5.347 5.347a8.3 8.3 0 0 1-2.61 1.767Zm-5.302 2.02 2.947-1.18-1.768-1.767z"
        />
    </svg>
);
const Memo = memo(DrawingEditorToolDrawV2Icon);
export default Memo;
